import { withInstall } from '@tav-ui/utils/with-install'
import ContextMenu from './src/context-menu'
const TaContextMenu = withInstall(ContextMenu)
export { TaContextMenu }
export default TaContextMenu
export * from './src/types'
